// Server times are ISO 8601. A value without "Z" or offset (older API responses) is a UTC
// wall-clock time: it is read as UTC so the browser shows it in its own time zone.
const WITHOUT_ZONE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/;

export function parseApiDate(value) {
  if (value == null || value === "") return null;
  const text = typeof value === "string" ? value.trim() : value;
  const date = new Date(typeof text === "string" && WITHOUT_ZONE.test(text) ? `${text}Z` : text);
  return Number.isFinite(date.getTime()) ? date : null;
}
